import React, { useRef, useState } from "react";
import { getImageUploadUrl, patchImageMetadata, deleteImage } from "../../api/messageRequests";
import { useTranslation } from "../../i18n/TranslationProvider";

// // In development, skip the real upload and simulate progress instead.
// const mockUpload = async (setProgress) => {
//   for (let i = 0; i <= 100; i += 20) {
//     setProgress(i);
//     await new Promise((r) => setTimeout(r, 200));
//   }
//   return `mock-uid-${Date.now()}`;
// };

// Asks out backend for a one-time Cloudflare Images upload URL.
const getUploadUrl = async () => {
  const res = await getImageUploadUrl();
  return res.data;
};

// Uploads the image to the one-time URL Cloudflare gave us.
const xhrUpload = (file, uploadUrl, setProgress) =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", file);

    const xhr = new XMLHttpRequest();

    // onprogress fires repeatedly as bytes are sent
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        setProgress(Math.round((e.loaded / e.total) * 100));
      }
    };

    xhr.onload = () => (xhr.status < 400 ? resolve() : reject(xhr.statusText));
    xhr.onerror = reject;

    xhr.open("POST", uploadUrl);
    xhr.send(formData);
  });


const ImageUploader = ({ onUploadComplete, onStatusChange, onManualCancel }) => {
  const { t } = useTranslation();
  // "idle" | "uploading" | "success" | "error"
  const [status, setStatus] = useState("idle");
  const [progress, setProgress] = useState(0);
  const [fileName, setFileName] = useState(null);
  const [uploadedUid, setUploadedUid] = useState(null);

  const inputRef = useRef(null);

  // notify the parent
   const updateStatus = (newStatus) => {
    setStatus(newStatus);
    if (onStatusChange) onStatusChange(newStatus);
  };

  const handleFile = async (file) => {
    if (!file) return;

    updateStatus("uploading");
    setFileName(file.name);

    try {

      // if (process.env.NODE_ENV === "development") {
      //   uid = await mockUpload(setProgress);
      // } else {
      const { uploadUrl, uid } = await getUploadUrl();

      setUploadedUid(uid);
      onUploadComplete(uid);

      await xhrUpload(file, uploadUrl, setProgress);
      // }



      await patchImageMetadata({
        imageId: uid,
        uploadType: "user-message",
      });

  
      updateStatus("success");

    } catch (err) {
      console.error(err);
      updateStatus("error");
    }
  };

    const handleRemove = async () => {
       if (onManualCancel) onManualCancel();
      console.log("deleting uid:", uploadedUid);
    if (uploadedUid) {
        try {
          // API call
          const res = await deleteImage(uploadedUid); 
          console.log("delete response:", res);
        } catch (err) {
          console.error("Failed to delete image from Cloudflare:", err);
        }
      }
    setUploadedUid(null);
    updateStatus("idle");
    setProgress(0);
    setFileName(null);
    if (inputRef.current) inputRef.current.value = "";
    onUploadComplete(null); // clear the uid in SendMessage
  };


  return (
    <div className="mt-2">

      {status === "idle" && (
        <div
          onClick={() => inputRef.current?.click()}
          style={{ border: "2px dashed #adb5bd", borderRadius: 8, padding: 16, textAlign: "center", cursor: "pointer", background: "#f8f9fa", fontSize: 13, color: "#6c757d" }}
        >
          {t("messages.imageUploader.selectPhoto")}
          
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => handleFile(e.target.files?.[0])}
          />
        </div>
      )}

      {status === "uploading" && (
        <div>
          <div style={{ fontSize: 12, color: "#6c757d", marginBottom: 4 }}>
            {t("messages.imageUploader.uploading")}… {progress}%
          </div>
          <div style={{ background: "#e9ecef", borderRadius: 4, height: 6 }}>
            <div style={{ width: `${progress}%`, height: "100%", background: "#0d6efd", borderRadius: 4, transition: "width 0.3s" }} />
          </div>
        </div>
      )}

      {status === "success" && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", background: "#d1e7dd", borderRadius: 6, fontSize: 13 }}>
          <span>{fileName}</span>
          <button type="button" onClick={handleRemove} style={{ marginLeft: "auto", background: "none", border: "none", cursor: "pointer", color: "#842029", fontWeight: "bold", fontSize: 16 }}>×</button>
        </div>
      )}

      {status === "error" && (
        <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 10px", background: "#f8d7da", borderRadius: 6, fontSize: 13, color: "#842029" }}>
          <span>
            {t("messages.imageUploader.uploadFailed")}
            <p className="small">{t("messages.imageUploader.failureMsg")}</p>
          </span>
          <button type="button" onClick={handleRemove} style={{ background: "none", border: "none", cursor: "pointer", color: "#842029", fontWeight: "bold" }}>×</button>
        </div>
      )}

    </div>
  );
};

export default ImageUploader;